/*jshint esversion: 6 */
import React from 'react';
import { connect } from 'react-redux';
import { ModalActions } from 'app/redux/actions.js';

function mapStateToProps(state) {
    return({
        modals: state.modals
    });
}

function mapDispatchToProps(dispatch) {
    return {
        addModal: (modal) => {
            dispatch(ModalActions.addModal(modal));
        },
        closeModal: (modal) => {
            dispatch(ModalActions.closeModal(modal));
        },
        closeAllModals: () => {
            dispatch(ModalActions.closeAllModals());
        },
        closeOtherModals:(modal) => {
            dispatch(ModalActions.closeOtherModals(modal));
        },
        popModal: () => {
            dispatch(ModalActions.popModal());
        }
	};
}

export default function ModalProvider(Component) {

    class ModalProvider extends React.Component {
        constructor(props) {
            super(props);

            this.isModalVisible = this.isModalVisible.bind(this);
        }

        isModalVisible() {
            return this.props.modals.stack.length ? true : false;
        }

        render() {
            return (
                <Component
                    isModalVisible={this.isModalVisible}
                    {...this.props}/>
            );
        }
    }

    ModalProvider.displayName = "ModalProvider";

    return connect(mapStateToProps, mapDispatchToProps)(ModalProvider);
};
